import Router from './Router'
import routerContainer from './routerContainer'

export default routerContainer(Router)
